import React, { useState, useEffect } from 'react';
import FlippexLoader from '../components/ui/FlippexLoader';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { useAuth, api } from '../context/AuthContext';
import { ArrowDownCircle, ArrowUpCircle, DollarSign, ArrowLeft } from 'lucide-react';

const TransactionsPage = () => {
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      const response = await api.get('/portfolio/transactions');
      setTransactions(response.data);
    } catch (error) {
      console.error('Error fetching transactions:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTransactionIcon = (type) => {
    if (type === 'deposit') return <ArrowDownCircle className="h-5 w-5 text-accent" />;
    if (type === 'dividend' || type === 'distribution') return <ArrowUpCircle className="h-5 w-5 text-success" />;
    return <DollarSign className="h-5 w-5 text-foreground-muted" />;
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <FlippexLoader size={64} animate={false} />
      </div>
    );
  }

  return (
    <div className="min-h-screen" data-testid="transactions-page">
      <Header />

      <div className="container mx-auto px-4 md:px-6 lg:px-8 py-12">
        <div className="flex items-center space-x-4 mb-8">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate('/dashboard')}
            data-testid="back-button"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-3xl font-heading font-bold">Transactions</h1>
        </div>

        <Card className="glass p-6">
          {transactions.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-foreground-muted">No transactions yet</p>
            </div>
          ) : (
            <div className="space-y-4">
              {transactions.map((transaction) => (
                <div
                  key={transaction.id}
                  className="flex items-center justify-between p-4 bg-background-subtle rounded-lg"
                  data-testid={`transaction-${transaction.id}`}
                >
                  <div className="flex items-center space-x-4">
                    {getTransactionIcon(transaction.type)}
                    <div>
                      <div className="font-semibold capitalize">{transaction.type}</div>
                      <div className="text-sm text-foreground-muted">
                        {new Date(transaction.created_at).toLocaleDateString()}
                      </div>
                      {transaction.notes && (
                        <div className="text-xs text-foreground-muted mt-1">{transaction.notes}</div>
                      )}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className={`text-lg font-bold ${
                      transaction.type === 'deposit' ? 'text-accent' :
                      (transaction.type === 'dividend' || transaction.type === 'distribution') ? 'text-success' :
                      'text-foreground'
                    }`}>
                      {(transaction.type === 'dividend' || transaction.type === 'distribution') ? '+' : ''}
                      €{transaction.amount.toLocaleString()}
                    </div>
                    <div className="text-xs text-foreground-muted capitalize">{transaction.status}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

export default TransactionsPage;
